import { Component, Input } from '@angular/core';

@Component({
    selector: 'cl-sub-toolbar',
    templateUrl: './sub-toolbar.component.html',
    styleUrls: ['./sub-toolbar.component.scss']
})
export class SubToolbarComponent {
    static $name: string = 'clSubToolbar';
    @Input() currentTitle: string;

    constructor(
    ) {
    }

}
